// Only the forms fixture page runs without a session; every other /dev page needs the logged-in providers.
export const isFormsFixturePage = (pathname: string): boolean =>
  import.meta.env.VITE_FORMS_FIXTURE_ENABLED === 'true' && /^\/dev\/forms\/?$/i.test(pathname);
